import countries from 'i18n-iso-countries';
import enLocale from 'i18n-iso-countries/langs/en.json';

// Register English locale
countries.registerLocale(enLocale);

export interface CountryItem {
  id: string;
  full_name_english: string;
  two_letter_abbreviation: string;
}

/**
 * Get all countries in the same data structure as the Magento GraphQL countries query.
 * Each country has: id, full_name_english, two_letter_abbreviation
 */
export function getCountries(): CountryItem[] {
  const alpha2Codes = Object.keys(countries.getAlpha2Codes());

  return alpha2Codes
    .map(code => ({
      id: code,
      full_name_english: countries.getName(code, 'en') || code,
      two_letter_abbreviation: code,
    }))
    .sort((a, b) => a.full_name_english.localeCompare(b.full_name_english));
}
